import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers, tabs } from "./config";

const ShipmentList = () => {

  return (
    <Table tableId="shipments" title="Shipment" icon={InventoryRoundedIcon} headers={headers} tabs={tabs} filters={filters} defaultSort="-date_created" idKey="shipment_id" tabField="shipment_type" />
  );
};

export default ShipmentList;